export const CurrencySymbols: Record<string, string> = {
  EUR: '€',
};
